import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 *  Approval Management Service
 * !== 결재 관리 서비스 ==!
 */
export const BASE = {
    path: `${process.env.REACT_APP_BASE_COMN}/comn/aprv`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/aprv/aprv-mgmt`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Approval Management" }],
};

export const URLS = {
    ptli0409006s: `${BASE.path}/AprvRqst`, // Approval Request Popup !== 결재요청 팝업 ==!
    ptli04090067: `${BASE.path}/AprvRqst`, // Approval Request Popup !== 사용자 조회 팝업 ==!
};

// Approval Status Code !== 결재 상태 코드 값 (승인,반려) ==!
const lastAprvYn = [
    { label: "Approval", value: "Y" },
    { label: "Return", value: "N" },
];

export const APIS = {
    // View Approval Waiting Status List !== 결재 대기 상태 목록 조회 ==!
    getAprvWaitList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/wait?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval in Progress Status List !== 결재 진행중 상태 목록 조회 ==!
    getAprvPrcdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/prcd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Completion Status List !== 결재 완료 상태 목록 조회 ==!
    getAprvCmptList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/cmpt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Request Status List !== 결재 요청 상태 목록 조회 ==!
    getAprvRqstList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/rqst?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    //  When selecting an Approval Path, View the List of Target Approvers !== 결재선 선택시 대상 결재자 목록 조회 ==!
    getAprvTrgtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/trgt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Customs list inquiry !== 세관 목록 조회 ==!
    getCsmtList: () => {
        return api.get(`${BASE.api}/cstmOfce`);
    },
    // Department list inquiry !== 부서 목록 조회 ==!
    getOrgDeptHierarchyList: () => {
        return api.get(`${BASE.api}/dept`);
    },

    getOrgDeptUsrList: (data: any) => {
        return api.get(`${BASE.api}/dept/usr`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // View Approval Path List !== 결재선 목록 조회 (결재요청 팝업용 결재선 목록 조회) ==!
    getAprvPathMgmtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval History List !== 결재 이력 목록 조회 ==!
    getAprvHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/hist?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Request Information !== 결재 요청 정보 조회 ==!
    getAprvRqstInfo: (data: any, usrId: string) => {
        return api.get(`${BASE.api}/rqst/${data}/${usrId}`);
    },
    // View Approval History Information !== 결재 이력 정보 조회 ==!
    getAprvHistInfo: (data: any) => {
        return api.get(`${BASE.api}/histInfo/${data.aprvId}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval History Information !== 결재 문서 정보 조회 ==!
    getDclaDocInfo: (data: any) => {
        return api.get(`${BASE.api}/dcla/${data}`);
    },
    // Save Approval Request Information !== 결재 요청 정보 저장 ==!
    saveAprvRqstInfo: (data: any) => {
        return api.post(`${BASE.api}/rqst`, {
            ...data,
        });
    },
    // Save Approval Processing Information !== 결재 처리 정보 저장 ==!
    saveAprvPrcsInfo: (data: any) => {
        return api.put(`${BASE.api}/prcss`, {
            ...data,
        });
    },
    // Save Approval Processing Information !== 결재 요청 취소 저장 ==!
    saveAprvCnclInfo: (data: any) => {
        return api.put(`${BASE.api}/cncl`, {
            ...data,
        });
    },

    // Search for approver information based on approver list parameters !== !== 결재자 목록 파라미터 기준 결재자 정보 조회 ==!
    getAprvRqstUsrList: (data: any) => {
        return api.get(`${BASE.api}/rqst-aprv-usr?`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Save Auth Approval Request Information !== 권한한 결재 요청 정보 저장 ==!
    saveAuthAprvRqstInfo: (data: any) => {
        return api.post(`${BASE.api}/auth-rqst`, {
            ...data,
        });
    },
};

export const SF_CSTM_OFCR_SRCH: TFormSchema = {
    id: "form_CstmSrch",
    schema: {
        cstmNm: { type: "text", label: "L_CSTM", readOnly: true },
        usrNm: { type: "text", label: "L_USR_NM", letterCase: "upper" },
        cstmOfceCd: { type: "text", label: "L_CSTM_OFCE_CD" },
        orgCd: { type: "text" },
        orgNm: { type: "text" },
        deptCd: { type: "text" },
        deptNm: { type: "text", label: "L_DEPT_NM" },
        usrId: { type: "text", label: "L_USR_ID", letterCase: "upper" },
    },
};

// Approval Status Search Form !== 결재 현황 검색 폼 ==!
export const SF_APRV_STAT_SRCH: TFormSchema = {
    id: "form_aprvStatSrch",
    schema: {
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_APRV_RQST_DT",
            start: { name: "aprvRqstStrtDt" },
            end: { name: "aprvRqstEndDt" },
        },
        aprvDocClsf: {
            // !== 신고 문서 코드에 따라 결재 문서 종류 보여주기 ==!
            type: "select",
            label: "L_APRV_DOC_CLSF",
            all: true,
            area: "comnCd",
            comnCd: "OSC0092",
        },
        aprvPrcssStatCd: { type: "select", label: "L_APRV_STAT_CD", all: true, area: "comnCd", comnCd: "OSC0096" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM" },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_CD", all: false, area: "comnCd", comnCd: "OSC0088" },
        aprvRqstUsrNm: { type: "text", label: "L_APRV_USR_NM" },
    },
};

// Approval Request Form !== 결재 요청 폼 ==!
export const SF_APRV_RQST_INFO: TFormSchema = {
    id: "form_aprvRqstInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        afPrcssUrlAddr: { type: "text", label: "L_AF_URL_ADDR" },
        aprvPrcssOrd: { type: "text", label: "L_APRV_PRCSS_ORD" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM", required: true },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN", required: true },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        aprvPrcssStatCdNm: { type: "text", label: "L_APRV_PROC_STAT" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvRqstDtm: { type: "text", label: "L_APRV_RQST_DT" },
        docNm: { type: "text", label: "L_APRV_DOC_NM" },
        docMakeUrlAddr: { type: "text", label: "L_DOC_MAKE_URL_ADDR" },
        aprvReffId: { type: "text", label: "L_DOC_MAKE_URL_ADDR" },
        scrnDocCd: { type: "text", label: "" },
    },
};

// Approval Request Popup Form !== 결재 요청 팝업 폼 ==!
export const SF_APRV_RQST_PPUP_INFO: TFormSchema = {
    id: "form_aprvRqstPpupInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssPathMgmtId: { type: "text", label: "L_APRV_PRCSS_PATH_MGMT_ID" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM", edit: false, mode: "view" },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN", required: true, controlSize: 10, maxLength: 200 },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvRqstDtm: { type: "text", label: "L_APRV_RQST_DT" },
        scrnDocCd: { type: "text", label: "L_APRV_RQST_DT" },
        cstmOfceCd: { type: "text", label: "L_CSTM_OFCE_CD" },
    },
};

// Approval Document Form !== 결재 문서 폼 ==!
export const SF_APRV_DOC_INFO: TFormSchema = {
    id: "form_aprvDocInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssPathMgmtId: { type: "text", label: "L_APRV_PRCSS_PATH_MGMT_ID" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_NM" },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN", rows: 3, controlSize: 10 },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvPrcssMetdCd: { type: "text", label: "L_APRV_PRCSS_METD_CD" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvRqstDtm: { type: "text", label: "L_APRV_RQST_DT" },
    },
};

// Approval History Form !== 결재 이력 폼 ==!
export const SF_APRV_HIST_INFO: TFormSchema = {
    id: "form_aprvHistInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        lastAprvYnNm: { type: "text", label: "L_APRV_PRCSS_STAT_CD", readOnly: true },
        aprvPrcssOpinCn: { type: "textarea", label: "L_APRV_PRCS_OPIN_CN" },
        usrNm: { type: "text", label: "L_APRV_USR" },
        aprvPrcssDtm: { type: "text", label: "L_APRV_PRCSS_DT", readOnly: true },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        aprvBsopClsfCd: { type: "text", label: "L_APRV_BSOP_CLSF_CD", readOnly: true },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvPrcssMetdCd: { type: "text", label: "L_APRV_PRCSS_METD_CD" },
    },
};

// Approval Processing Status Form !== 결재 처리 폼 ==!
export const SF_APRV_PRCS_INFO: TFormSchema = {
    id: "form_aprvPrcsInfo",
    schema: {
        lastAprvYn: { type: "radio", label: "L_APRV_PRCSS_STAT_CD", options: lastAprvYn, required: true },
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssOpinCn: { type: "textarea", label: "L_APRV_PRCS_OPIN_CN", rows: 3, controlSize: 10 },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        scrnDocCd: { type: "text", label: "L_APRV_BSOP_CLSF_NM", readOnly: true },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvPrcssDtm: { type: "text", label: "L_APRV_RQST_DT" },
        aprvPrcssOrd: { type: "text", label: "L_APRV_RQST_DT" },
        afPrcssUrlAddr: { type: "text", label: "L_AF_URL_ADDR" },
    },
};

// Approval Path Grid Popup Schema  !== 결재선 목록 그리드 스키마 (결재요청 팝업용)  ==!
export const SG_APRV_PATH_RQST_LIST: TGridSchema = {
    id: "grid_aprvPathRqstList",
    options: { index: true, checkbox: false, height: 123 },
    head: [
        { cells: [{ header: "L_APRV_PATH_ID", binding: "aprvPrcssPathMgmtId", width: 200 }], show: false },
        { cells: [{ header: "L_APRV_PATH_NM", binding: "aprvPrcssPathNm", width: 200 }] },
        { cells: [{ header: "L_APRV_PATH_DESC", binding: "aprvPrcssPathDesc", width: "*" }] },
        // { cells: [{ header: "L_USE_YN", binding: "delYn", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "aprvPrcssPathMgmtId", edit: false }] },
        { cells: [{ binding: "aprvPrcssPathNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssPathDesc", edit: false, align: "left" }] },
        // { cells: [{ binding: "delYn", edit: false }] },
    ],
};

// When selecting a Customs Office, check the list of target approvers Grid Schema !== 세관 선택시 대상자 목록 그리드 스키마  ==!
export const SG_APRV_CSTM_USR_LIST: TGridSchema = {
    id: "grid_aprvCstmUsrList",
    options: { index: true, checkbox: true, height: 300 },
    head: [
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }], show: false },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_USER_NM", binding: "usrNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "cstmOfceCd", edit: false }] },
        { cells: [{ binding: "cstmNm", edit: false, align: "left" }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
    ],
};

// When selecting a Customs Office, check the list of target approvers Grid Schema !== 세관 선택시 대상자 목록 그리드 스키마  ==!
export const SG_APRV_ORG_USR_LIST: TGridSchema = {
    id: "grid_aprvCstmUsrList",
    options: { index: true, checkbox: true, height: 300 },
    head: [
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "*" }], show: false },
        { cells: [{ header: "L_DEPT_CD", binding: "deptCd", width: "*" }], show: false },
        { cells: [{ header: "L_DEPT", binding: "deptNm", width: "*" }], show: false },
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "*" }] },
        { cells: [{ header: "L_USER_NM", binding: "usrNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "orgCd", edit: false }] },
        { cells: [{ binding: "deptCd", edit: false }] },
        { cells: [{ binding: "deptNm", edit: false, align: "left" }] },
        { cells: [{ binding: "usrDmnId", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
    ],
};

// Customs List Grid Schema !== 세관 목록 그리드 스키마  ==!
export const SG_CSTM_LIST: TGridSchema = {
    id: "grid_cstmList",
    options: { index: true, checkbox: true, height: 120 },
    head: [
        { cells: [{ header: "L_CSTM", binding: "csmtNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "csmtNm", edit: false, align: "left" }] },
        { cells: [{ binding: "cstmOfceCd", edit: false, align: "left" }] },
    ],
};

// List of approvers in the Organization chart tab Grid Schema !== 결재자 목록 그리드 스키마  ==!
export const SG_APRV_USR_LIST: TGridSchema = {
    id: "grid_aprvTrgtUsrList",
    options: { index: true, checkbox: true, height: 123 },
    head: [
        // { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: 150 }] },
        { cells: [{ header: "L_USER_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_DEPT", binding: "deptNm", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "cstmNm", edit: false, align: "left" }] },
        { cells: [{ binding: "usrDmnId", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "deptNm", edit: false, align: "left" }] },
    ],
};

// Waitting for approval Status Grid Schema !== 결재 대기 상태 목록 그리드 스키마  ==!
export const SG_APRV_WAIT_LIST: TGridSchema = {
    id: "grid_aprvWaitList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_PROC_STAT", binding: "aprvPrcssStatCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_DT", binding: "aprvRqstDtm", width: 150 }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false }] },
    ],
};

//  approval in Progress Status Grid Schema !== 결재 진행중 목록 그리드 스키마  ==!
export const SG_APRV_PRCD_LIST: TGridSchema = {
    id: "grid_aprvPrcdList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_PROC_STAT", binding: "aprvPrcssStatCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_DT", binding: "aprvRqstDtm", width: 150 }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false }] },
    ],
};

// Completed Approval Status Grid Schema !== 결재 완료 목록 그리드 스키마  ==!
export const SG_APRV_CMPT_LIST: TGridSchema = {
    id: "grid_aprvCmptList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_PROC_STAT", binding: "aprvPrcssStatCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_DT", binding: "aprvRqstDtm", width: 150 }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false }] },
    ],
};

// Request list for approval Status Grid Schema !== 결재 요청 상태 목록 그리드 스키마  ==!
export const SG_APRV_RQST_LIST: TGridSchema = {
    id: "grid_aprvRqstList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_PROC_STAT", binding: "aprvPrcssStatCdNm", width: 150 }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 150 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: 150 }] },
        { cells: [{ header: "L_APRV_RQST_DT", binding: "aprvRqstDtm", width: 150 }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
    ],
};

//  approval in Progress Status Grid Schema !== 결재 이력 목록 그리드 스키마  ==!
export const SG_APRV_HIST_LIST: TGridSchema = {
    id: "grid_aprvHistList",
    options: { index: true, checkbox: false, height: 150 },
    head: [
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
        //{ cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: 200 }] },
        //{ cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_USR", binding: "usrNm", width: 300 }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_APRV_TP", binding: "aprvPrcssMetdCdNm", width: 300 }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 300 }], show: false },
    ],
    body: [
        { cells: [{ binding: "aprvId", edit: false }] },
        //{ cells: [{ binding: "bsopClsfCd", edit: false }] },
        //{ cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "cstmNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false, align: "left" }] },
    ],
};
